import type { LegacyTrackingEventName } from '@shared/tracking/legacy-tracking-events';

export const legacyTrackableEvents: readonly LegacyTrackingEventName[] = [
    'ambition-added',
    'bookmark-learning-opportunity',
    'candidate-shortlist',
    'job-applied',
    'learning-opportunity-taken',
    'profile-preview',
    'recommendation-used',
];
